module.exports = __webpack_public_path__ + "static/media/logo.e7af25a2.png";


//////////////////
// WEBPACK FOOTER
// ./src/landlords/images/logo.png
// module id = 354
// module chunks = 0